export const KEYBOARD_INSET_PROPERTY = "--mt-keyboard-inset";
export const KEYBOARD_INSET_EVENT = "mt:keyboard";

function keyboardHeight(event: Event): number {
  if (!(event instanceof CustomEvent)) return 0;
  const value = Number((event.detail as { height?: unknown } | null)?.height);
  return Number.isFinite(value) && value >= 0 ? value : 0;
}

/**
 * Consume the exact keyboard overlap measured by TiltRacingKeyboard.swift.
 *
 * Mobile Safari resizes its viewport and never emits this event, so browser
 * behavior is unchanged. The iOS Tauri WebView does not resize; fixed sheets
 * consume this one CSS token to lift their interactive footer above the
 * keyboard without adding the home-indicator inset twice.
 */
export function installNativeKeyboardInsets(
  target: Window = window,
  root: HTMLElement = document.documentElement,
): () => void {
  const apply = (event: Event) => {
    root.style.setProperty(
      KEYBOARD_INSET_PROPERTY,
      `${keyboardHeight(event)}px`,
    );
  };

  root.style.setProperty(KEYBOARD_INSET_PROPERTY, "0px");
  target.addEventListener(KEYBOARD_INSET_EVENT, apply);
  return () => {
    target.removeEventListener(KEYBOARD_INSET_EVENT, apply);
    root.style.removeProperty(KEYBOARD_INSET_PROPERTY);
  };
}
